import { ApplicationState } from 'state';

export type StoreKey = keyof ApplicationState;

export function FetchFromLocalStorage<T>(key: StoreKey): T {
    return JSON.parse(localStorage.getItem(key) as string) as T;
}
